export default "__VITE_ASSET__HlM3ymY2__"